// Utility per web push notifications
import { api } from "./api";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const isPushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const getPushPermission = () =>
  isPushSupported() ? Notification.permission : "unsupported";

export const subscribeToPush = async () => {
  if (!isPushSupported()) throw new Error("Push non supportato su questo browser");
  const reg = await navigator.serviceWorker.ready;
  const existing = await reg.pushManager.getSubscription();
  if (existing) return { subscription: existing, alreadySubscribed: true };
  const { data } = await api.get("/push/vapid-public-key");
  if (!data.publicKey) throw new Error("Server push non configurato");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permesso notifiche negato");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.publicKey),
  });
  await api.post("/push/subscribe", sub.toJSON());
  return { subscription: sub, alreadySubscribed: false };
};

export const unsubscribeFromPush = async () => {
  if (!isPushSupported()) return false;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return false;
  await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
  await sub.unsubscribe();
  return true;
};
